import Vue from "vue";
import VueGtm from "vue-gtm";
// Legacy router syntax is unsupported by ESLint's import parser.
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import router from "./router";
import store from "./store";
// Legacy optional chaining is unsupported by ESLint's import parser.
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import api from "./app/Api";
import initAccountConsent from "./services/accountConsent";
import initGa4UserId from "./services/ga4";
import { hasAnalyticsConsent, subscribeConsent } from "./services/consent";

initAccountConsent(store, api);
initGa4UserId(store);

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_KEY || (
    (process.env.VUE_APP_STRIPE_KEY || "").includes("test") ? "GTM-MB473HGQ" : "GTM-MF94TXDL"
  ),
  enabled: process.env.NODE_ENV === "production" && hasAnalyticsConsent(),
  debug: false,
  vueRouter: router,
});

subscribeConsent((next, previous) => {
  const enabled = process.env.NODE_ENV === "production" && next.analytics;
  Vue.gtm.enable(enabled);
  if (enabled && !previous.analytics && router.currentRoute.name) {
    Vue.gtm.trackView(router.currentRoute.name, router.currentRoute.fullPath);
  }
});
